import { Typography } from '@material-ui/core';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { FieldLabel } from 'src/components/FieldLabel';

import useStyles from './useStyles';

export const FieldHeader = ({
  classes,
  className,
  label,
  subtitle,
  hint,
  isHintQuestion,
  isOptional,
  LabelProps,
  ...restProps
}) => {
  const styles = useStyles({ classes });

  return (
    <div
      className={cx(styles.root, className)}
      {...restProps}
    >
      <FieldLabel
        className={styles.label}
        label={label}
        hint={hint}
        isQuestion={isHintQuestion}
        isOptional={isOptional}
        {...LabelProps}
      />

      {subtitle && <Typography className={styles.subtitle}>{subtitle}</Typography>}
    </div>
  );
};

FieldHeader.propTypes = {
  classes: PropTypes.shape({}),
  className: PropTypes.string,
  hint: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  label: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  subtitle: PropTypes.string,
  isHintQuestion: PropTypes.bool,
  isOptional: PropTypes.bool,
  LabelProps: PropTypes.shape(),
};

FieldHeader.defaultProps = {
  classes: null,
  className: null,
  hint: null,
  label: '',
  subtitle: '',
  isHintQuestion: false,
  isOptional: false,
  LabelProps: null,
};
